export default __webpack_public_path__ + "static/feature_03-3ca71917115bc99be2bde5edf682cea6.png";